import { CancelTokenSource } from 'axios';
import { ITag } from '../types';
import { ApiRepository } from './main repository/api.repository';

export namespace TagService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/tags`;

  export const getTags = async (cancelTokenSource: CancelTokenSource, ids?: number[]): Promise<ITag[]> => {
    return ApiRepository.Core().get(BASE_API, { ids: ids?.join(',') }, { cancelToken: cancelTokenSource.token });
  };

  export const updateTag = async (
    cancelTokenSource: CancelTokenSource,
    tagID: number | undefined,
    tagName: string | undefined,
    description: string | undefined
  ): Promise<ITag> => {
    return ApiRepository.Core().put(
      `${BASE_API}/${tagID}`,
      {
        name: tagName,
        description,
      },
      undefined,
      { cancelToken: cancelTokenSource.token }
    );
  };

  export const createTag = async (
    cancelTokenSource: CancelTokenSource,
    tagName: string,
    description: string | undefined
  ): Promise<ITag> => {
    return ApiRepository.Core().post(
      BASE_API,
      {
        name: tagName,
        description,
      },
      undefined,
      { cancelToken: cancelTokenSource.token }
    );
  };

  export const deleteTag = async (tagID: number): Promise<ITag> => {
    return ApiRepository.Core().delete(`${BASE_API}/${tagID}`);
  };
}
